export const SHIPPING_CONFIDENCE_EXPERIMENT =
  'tse_ghost_seller_buyer_friction_v1';
